"use strict";

/*global
 window, document, console, require, Foundation
 */

import 'lib/foundation-explicit-pieces';
import sal from 'sal.js';

document.addEventListener('DOMContentLoaded', () => {
$(document).foundation();

	// init sal fade
	sal({
		threshold: 0.5,
	});

// frontpage number counter
	$('.count').each(function (index) {

		const str = $(this).text();

		$(this).prop('Counter', 0).animate({
			Counter: $(this).text()
		}, {
			duration: 3500,
			easing: 'swing',
			step: function (now) {
				$(this).text(Math.ceil(now));
			}
		});

	});

	// NAV SCROLLER

	var loggedPos = 0;

	var prevScrollpos = window.pageYOffset;
	window.onscroll = function() {
		var currentScrollPos = window.pageYOffset;

		loggedPos = (prevScrollpos - 30);

		if (prevScrollpos > currentScrollPos) {

			if (prevScrollpos > currentScrollPos) {
				if (currentScrollPos < loggedPos) {
					$('header').removeClass('hidden').addClass('visible');
				}
			}

		} else {
			if(prevScrollpos < 200 ) {
				// if scrolld less than 200px from top, show always.
				$('header').removeClass('hidden').addClass('visible');
			} else {

				if($('header').hasClass('hidden')) {
					$('.nav-icon').removeClass('open');
				} else {
					$('header').removeClass('visible').addClass('hidden');
				}

				if($('.nav-toggle-label').hasClass('open')) {
					$('.mobile').removeClass('visible');
					$('.nav-toggle-label').removeClass('open');
				}
			}
		}

		prevScrollpos = currentScrollPos;

	};

	// var navIcon = $('.nav-icon');
	var navIcon = $('.nav-toggle');

	navIcon.on('click', function () {
		$('.nav-toggle-label').toggleClass('open');
		$('.mobile').toggleClass('visible');
	});




	// TESTIMONIALS SCROLLER

	$('.testimonials').slick({
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		dots: true,
		arrows: false,
		infinite: true,
	});





});